var c = Object.defineProperty;
var u = (r, e, s) => e in r ? c(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s;
var t = (r, e, s) => u(r, typeof e != "symbol" ? e + "" : e, s);
import { WebStorageStateStore as h, UserManager as l } from "oidc-client";
import { S as m } from "../errors-YTprc4A2.mjs";
import { e as a } from "../helpers-CNa1KUVl.mjs";
class k {
  /**
   * Constructor for managing the user credentials
   * @param authority authorization endpoint url (e.g: https://dev.id.core-non-production.servicevic.local:443/openam/oauth2/realms/root/realms/whitelabel)
   * @param client_id type of client to authenticate (e.g: loa2)
   * @param redirect_uri callback redirect uri after processing user request
   * @param storage location of where to store the user credentials (defaults to "sessionStorage")
   */
  constructor(e, s, i, o, n = sessionStorage) {
    t(this, "manager");
    t(this, "storage");
    t(this, "settings");
    t(this, "sessionKey");
    /**
     * sign in the user to the authorization endpoint. throw an exception on error
     */
    t(this, "signInUser", async () => (await this.manager.signinRedirect(), this.manager.signinRedirectCallback().then(this.getUserData).catch((e) => {
      throw a(e), e;
    })));
    /**
     * Signs out and ends the user sesseion
     */
    t(this, "signOut", async () => (await this.manager.signoutRedirect(), await this.manager.signoutRedirectCallback()));
    /**
     * Extract the user information from oAuth provider, otherwise throw an error if user not exist
     */
    t(this, "getUserData", async () => {
      try {
        const e = await this.manager.getUser();
        if (!e)
          throw new m("No user details found.");
        return e;
      } catch (e) {
        throw a(e), e;
      }
    });
    /**
     * process response from the authroization endpoint
     */
    t(this, "signInCallback", async () => {
      try {
        if (await this.manager.signinRedirectCallback())
          return this.getUserData();
      } catch (e) {
        a(e);
      }
    });
    /**
     * Get JWT Tokens that stored in sessionStorage, otherwise throws an exception
     *  - Access Token: getUserInfoAfterAuth().access_token
     *  - ID Token: getUserInfoAfterAuth().id_token
     */
    t(this, "getUserInfo", () => {
      const e = this.storage.getItem(this.sessionKey);
      if (e)
        return JSON.parse(e);
    });
    this.settings = {
      scope: "openid customer:rw profile email",
      authority: e,
      client_id: s
      // Come from remote call
    }, this.storage = n, this.sessionKey = `sv-tokenuser:${this.settings.authority}:${this.settings.client_id}`;
    const g = {
      redirect_uri: i,
      post_logout_redirect_uri: o,
      ...this.settings,
      response_type: "code",
      loadUserInfo: !0,
      revokeAccessTokenOnSignout: !0,
      extraQueryParams: { createFlag: "ca" },
      userStore: new h({ prefix: "sv-token", store: n })
    };
    this.manager = new l(g);
  }
}
export {
  k as default
};
